import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { Toggle } from "./Toggle";
export const ToggleInput = ({ id, fieldName, dataTestId, className, disabled }) => {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: fieldName, render: ({ field: { value, onChange } }) => (_jsx(Toggle, { id: id, value: value, onChange: onChange, dataTestId: dataTestId, className: className, disabled: disabled })) }));
};
//# sourceMappingURL=ToggleInput.js.map